import React from 'react';
import { IoIosArrowForward } from "react-icons/io";


const KidepoHeadrer = () => {
  return (
    <>
      <section id="hero" className="main-banner">
        <div className="container">
          <div className="breadcrumb-block">
            <h1 className="text-white">Kidepo Valley National Park</h1>
            <div className="breadcrumb-merge-5px-gap">
              <a href="/" className="breadcrumb">
                Home
              </a>
              <div className="icon">
                <IoIosArrowForward />
              </div>
              <a href="/blog" className="breadcrumb">
                Blog
              </a>
              <div className="icon">
                <IoIosArrowForward />
              </div>
              <div className="breadcrumb">
                Uganda’s Ultimate Wilderness Experience
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default KidepoHeadrer;
